import { Node, mergeAttributes } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import Component from "./ColumnNode.vue";

export const Column = Node.create({
    name: "column",
    group: "column",
    content: "(paragraph|heading|button|image|html|socials)+",
    isolating: true,
    selectable: false,

    renderHTML({ HTMLAttributes }) {
        const attrs = mergeAttributes(HTMLAttributes, { class: "column" });
        return ["div", attrs, 0];
    },

    addNodeView() {
        return VueNodeViewRenderer(Component as Parameters<typeof VueNodeViewRenderer>[0]);
    },
});
